// extracted by mini-css-extract-plugin
export default {"wrapper":"winner_wrapper__X5jCE"};